<template>
    <div class="header" :class="{'transparent':homeActive,'headerOpacity':opacityActive}">
        <div class="header-content clearfix">
                <h1><img :src="groupLogo" class="logo-img" :alt="hospitalName"></h1>
                <div class="nav-right">
                    <ul class="clearfix nav" v-if="flag">
                        <h2 class="fl nav-li" :class="{'active_branch':/index/.test(this.$route.path)}"><router-link class="nav-link" :to="homeIndex" title="首页">首页</router-link></h2> 
                        <h2 class="fl nav-li" :class="{'active_branch':item.flag}" v-for="(item,index) in menusList" :key="index">
                            <router-link  class="nav-link" :to="{path:'/'+item.link+'/'+short_name+'.html'}" :title="item.item">{{item.item}}</router-link>
                        </h2>
                    </ul>
                </div>            
        </div>            
    </div>   
</template>

<script>
export default {
    data() {
        return {
            hospitalName:'',
            mobile_domain:'',
            opacityActive:false,
            menusList:[],
            flag:false,
            homeIndex:'',
            homeActive:true,
            short_name:this.$route.params.short_name
        };
    },
    computed:{
        groupLogo(){
            return this.$store.getters.getGroupConfig.logo;
        }  
    },
    created(){
       this.getConfig();
       this.homeIndex='/index/'+sessionStorage.getItem('english_short_name')+'.html';
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll)
    },
    methods:{
        handleScroll(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
            if(scrollTop>100){
                this.opacityActive=true;
            }
            else{
                this.opacityActive=false;
            }
        },
        getConfig(){
            this.$axios.post(this.api.index.config,{},res =>{
                this.hospitalName = res.data.hospitalname;
                this.$store.dispatch('setGroupConfig',res.data);
                this.$store.dispatch('setCopyright',res.data.copy);
                this.mobile_domain=res.data.mobile_domain;
                this.menusList=res.data.menu_list;
                var matchUrl;
                for(var i in this.menusList){
                    matchUrl=this.menusList[i].link;
                    if(this.$route.path.indexOf(matchUrl) != -1){
                        this.$set(this.menusList[i], 'flag', true);
                    }
                    else{
                        this.$set(this.menusList[i], 'flag', false);
                    }
                }
                this.flag=true;
                if((this.$route.path.indexOf('/index')!=-1)||this.$route.path.indexOf('/hospital')!=-1){
                    this.homeActive=true;
                }
                else{
                    this.homeActive=false;
                }
                var pcflag=this.IsPC();
                if(!pcflag){
                    var mobile_path;
                    if(this.$route.path.indexOf('search') != '-1'){
                        mobile_path='http://'+this.mobile_domain+'/branch/index/'+this.$route.params.short_name;
                    }
                    else{
                        mobile_path='http://'+this.mobile_domain+'/branch'+this.$route.fullPath;
                    }
                    window.location.href=mobile_path;
                }
            });  
        },
        IsPC(){  
            var userAgentInfo = navigator.userAgent;
            var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
            var flag = true;  
            for (var v = 0; v < Agents.length; v++) {  
                if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
            }  
            return flag;  
        },
    },
    watch: {
        $route( to , from ){
            this.short_name=this.$route.params.short_name;
            this.getConfig();
            this.homeIndex='/index/'+sessionStorage.getItem('english_short_name')+'.html';
        }
    },
};
</script>
<style scoped>
    .transparent{background:rgba(255,255,255,0.8)}
    .headerOpacity{background:rgba(255,255,255,1)}
</style>



// WEBPACK FOOTER //
// src/components/HeaderChild.vue